<template>
  <div class="box white p-3">
    <K2Row space-between="true" class="border-bottom mb-4">
      <K2Text bold="true" class-name="mb-3" :style="{ fontSize: uiVariable.fontSize.lg }">
        <!--{{lang("Select Development Goals")}}-->
        {{ isMoment ? lang('Analysis (moment)') : lang('Analysis') }}
      </K2Text>
      <K2Row>
        <div v-b-toggle="'goal'">
          <K2Icon color="black" name="expand_less" class="when-open" />
          <K2Icon color="black" name="expand_more" class="when-closed" />
        </div>
      </K2Row>
    </K2Row>
    <b-collapse id="goal" visible>
      <div class="" style="min-height: 200px">
        <K2Text font-size="13px" align="left" class="w-100 d-block k2Tag mb-2"> **{{ lang('Please select a minimum of 3 Learning Domains') }} </K2Text>
        <K2Row>
          <div class="informationContentEach flex-grow-1 me-2">
            <el-select
              v-model="porDevelopmentDomain"
              :placeholder="lang('Select Learning Domain')"
              class="pro-edt-select w-100"
              @change="handleGoal(porDevelopmentDomain)"
            >
              <el-option v-for="(item, index) in porDevelopmentDomainList" :key="index" :label="item.Str_SortBy" :value="item.Str_SortBy"> </el-option>
            </el-select>
          </div>
          <div class="informationContentEach flex-grow-1 me-2">
            <el-select
              v-model="porDevelopmentGoal"
              :placeholder="lang('Select Learning Goal')"
              class="pro-edt-select w-100"
              @change="handleKsd(porDevelopmentGoal)"
            >
              <el-option v-for="(item, index) in porDevelopmentGoalList" :key="index" :label="item.Str_SortBy" :value="item.Str_SortBy"> </el-option>
            </el-select>
          </div>
          <div class="informationContentEach flex-grow-1 me-2">
            <el-select
              v-model="porDevelopmentIndicator"
              multiple
              collapse-tags
              class="pro-edt-select w-100"
              :placeholder="lang('Select Knowledge, Skills and Dispositions (KSD)')"
            >
              <el-option v-for="item in porDevelopmentIndicatorList" :key="item.PlnMasIndicator" :label="item.PlnMasIndicator" :value="item.PlnMasIndicator">
              </el-option>
            </el-select>
          </div>
          <K2Button @onclick="setValidateDropdown()" theme="2">
            {{ lang('Add') }}
          </K2Button>
        </K2Row>
        <!--K2Row v-else>
                    <div class="informationContentEach  flex-1 me-2">
                        <el-select v-model="porDevelopmentDomain"
                                   :placeholder="lang('Select Development Goals (moment)')"
                                   class="pro-edt-select w-100"
                                   @change="handleIndicator(porDevelopmentDomain)">
                            <el-option
                                    v-for="(item, index) in porDevelopmentDomainList"
                                    :key="index"
                                    :label="item.Str_SortBy"
                                    :value="item.Str_SortBy">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="informationContentEach  flex-1  me-2">
                        <el-select v-model="porDevelopmentIndicator" :placeholder="lang('Select Indicator')"
                                   class="pro-edt-select w-100">
                            <el-option
                                    v-for="(item, index) in porDevelopmentIndicatorList"
                                    :key="item.PlnMasIndicator"
                                    :label="item.PlnMasIndicator"
                                    :value="item.PlnMasIndicator">
                            </el-option>
                        </el-select>
                    </div>
                    <K2Button @onclick="setValidateDropdown()" theme="2">
                        {{lang("Add")}}
                    </K2Button-->
        <!--<K2Button :disabled="countMaxAnalysis()" @onclick="setValidateDropdown()" theme="2">-->
        <!--{{lang("Add")}}-->
        <!--</K2Button>-->
        <!--                </K2Row>-->
        <div v-if="porDevelopmentObject.length > 0">
          <!--<label>{{lang("You have selected")}}</label>-->
          <div class="responsive-table customScroll">
            <div class="goal2" v-for="(porDevelopmentObjectValueInfo, index) in porDevelopmentObject" :key="index">
              <div class="goal2__header mb-2">
                <K2Row class="mb-2">
                  <K2Icon :color="uiVariable.color.icon" name="assignment" class="me-2" :font-size="uiVariable.fontSize.lg" />
                  <K2Text bold="true">{{ porDevelopmentObjectValueInfo.Domain }}</K2Text>
                </K2Row>
                <div v-for="(porDevelopmentItem, index) in porDevelopmentObjectValueInfo.ItemList" :key="index" class="mb-2 porDevelopmentItem ps-3">
                  <K2Row align="center" class="mb-2" space-between="true">
                    <K2Row class="me-4" align="center">
                      <el-checkbox v-model="porDevelopmentItem.termlyReport" class="text-center me-2 mb-0" />
                      Summative Report

                      <K2Confirm
                        title="Are you sure you want to delete this post?"
                        :hideCancel="true"
                        theme="2"
                        style="border: 0"
                        class="ms-2 border-0"
                        background="transparent"
                        :color="uiVariable.color.purple"
                        :label="lang('Preview')"
                      >
                        <div class="p-3">
                          <div class="mb-2">
                            <K2Text bold="true">{{ lang('Learning Domain') }}:</K2Text>
                            <br />
                            <K2Text>{{ porDevelopmentItem.Domain }}</K2Text>
                          </div>
                          <div class="mb-2">
                            <K2Text bold="true">{{ lang('Learning Goal') }}:</K2Text>
                            <br />
                            <K2Text>{{ porDevelopmentItem.Goals }}</K2Text>
                          </div>
                          <div class="mb-2">
                            <K2Text bold="true">{{ lang('KSD') }}:</K2Text>
                            <br />
                            <span v-html="porDevelopmentItem.Indicator"></span>
                          </div>
                        </div>
                      </K2Confirm>
                    </K2Row>
                    <K2Row justify_content="center" align="center">
                      <K2Icon
                        link="true"
                        @onclick="removeSelectedGoals(index, porDevelopmentObjectValueInfo.Domain)"
                        name="delete"
                        class="mt-1"
                        :font-size="uiVariable.fontSize.lg"
                        :color="uiVariable.color.error"
                      />
                    </K2Row>
                  </K2Row>
                  <K2Row class="mb-2" v-if="porDevelopmentItem.Goals">
                    <K2Text text-align="left" :color="uiVariable.color.icon"> Learning Goal: {{ porDevelopmentItem.Goals }} </K2Text>
                  </K2Row>
                  <K2Editor v-model="porDevelopmentItem.Indicator" @input="handleRemarks" :passContent="porDevelopmentItem.Indicator" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import K2Icon from '../../../../uiComponents/k2Icon/k2MAIcon'
import K2Row from '../../../../uiComponents/k2Row/k2Row'
import uiVariable from '../../../../config/uiVariable'
import K2Button from '../../../../uiComponents/k2Button/k2Button'
import K2Text from '../../../../uiComponents/k2Text/k2Text'
import Cookies from 'js-cookie'
import { lang } from '../../../../locale'
import K2ToolTip from '../../../../uiComponents/k2ToolTip/k2ToolTip'
import K2Confirm from '../../../../uiComponents/k2Confirm/k2Confirm'
import K2Checkbox from '../../../../uiComponents/k2Checkbox/k2Checkbox'
import K2Editor from '../../../../uiComponents/k2Editor/k2Editor'
import { reorderArray } from '@/helper/utily'

export default {
  name: 'activityGoal',
  components: { K2Editor, K2Checkbox, K2Confirm, K2ToolTip, K2Text, K2Button, K2Row, K2Icon },
  props: [
    'handleBack',
    'mselectedstudents',
    'misselectedclasses',
    'goalsList',
    'porDevelopmentDomainList',
    'loadDomainList',
    'tselectedGoals',
    'layoutConfig',
    'isMoment',
    'is3LevelGoals',
  ],
  watch: {
    tselectedGoals: function (value) {
      // watch it
      if (value) {
        let newGoalList = []
        value.forEach(x => {
          const exist = newGoalList.find(d => d.Domain === x.Domain)
          if (exist) {
            exist.ItemList.push(x)
          } else {
            newGoalList.push({
              Domain: x.Domain,
              ItemList: [x],
            })
          }
        })
        this.porDevelopmentObject = newGoalList
        this.$emit('loadDomainList', this.porDevelopmentObject)
        if (!this.is3LevelGoals) {
          this.$emit('loadDomainList', this.porDevelopmentObject)
        }
      }
    },
  },
  data() {
    return {
      uiVariable: uiVariable,
      ddlDomain: '',
      ddlLearningMomentsList: [],
      ddlIndicator: '',
      ddlSchool: '',
      selectedLearningMomentsListInt: [],
      ddlGoalList: [],
      indicatorList: [],
      porDevelopmentObject: [],
      arr_indicatorList: [],
      ddlGoalsList: [],
      porDevelopmentDomain: '',
      porDevelopmentGoal: '',
      porDevelopmentIndicator: '',
      porDevelopmentIndicatorList: [],
      porDevelopmentGoalList: [],
      selectedLearningMomentsList: [
        {
          prop: 'PlnMasDomain',
          label: lang('Domain'),
        },
        // {
        //   prop: "PlnMasGoals",
        //   label: "Goals"
        // },
        {
          prop: 'PlnMasIndicator',
          label: lang('Indicator'),
        },
      ],
    }
  },
  mounted() {
    this.init()
    const self = this
  },
  methods: {
    lang,
    async init() {
      this.ddlSchool = Cookies.get('schoolSession')
    },
    showLoading() {
      this.$vs.loading()
    },
    hideLoading() {
      this.$vs.loading.close()
    },
    handleGoal(value) {
      this.porDevelopmentGoalList = []
      this.porDevelopmentGoal = ''
      this.porDevelopmentIndicator = ''
      this.porDevelopmentDomainList.forEach(item => {
        if (item.Str_SortBy === value) {
          this.porDevelopmentGoalList = item.ArrObj_Items
        }
      })
    },
    handleKsd(value) {
      this.porDevelopmentIndicatorList = []

      this.porDevelopmentGoalList.forEach(item => {
        if (item.Str_SortBy === value) {
          this.porDevelopmentIndicatorList = item.ArrObj_Items
        }
      })
      this.porDevelopmentIndicatorList = reorderArray(this.porDevelopmentIndicatorList)
    },
    handleIndicator(value) {
      this.porDevelopmentIndicatorList = []

      this.porDevelopmentDomainList.forEach(item => {
        if (item.Str_SortBy === value) {
          this.porDevelopmentIndicatorList = item.ArrObj_Items
        }
      })
    },
    removeIndicator(row) {
      this.selectedLearningMomentsListInt = this.selectedLearningMomentsListInt.filter(m2 => m2.PlnMasIndicator !== row.PlnMasIndicator)
    },
    setValidateDropdown() {
      let selectedGoalList = []
      if (this.porDevelopmentIndicator?.length > 0) {
        this.porDevelopmentIndicator?.forEach(d => {
          if (!this.arr_indicatorList.includes(d)) {
            this.arr_indicatorList.push(d)
          }
          let found = this.goalsList?.find(m => m.PlnMasIndicator === d)
          if (found) {
            selectedGoalList.push(found)
          }
        })
      }
      // this.porDevelopmentObject = [];
      selectedGoalList?.forEach(d => {
        let porDevelopmentObjectTemp = {
          Domain: d.PlnMasDomain,
          Goals: d.PlnMasGoals,
          Indicator: d.PlnMasIndicator,
          KeyId: d.PlnMasID,
        }
        this.handleAnalysisGrouping(porDevelopmentObjectTemp)
      })

      this.countMaxAnalysis()
      this.porDevelopmentDomain = ''
      this.porDevelopmentIndicator = ''
      this.porDevelopmentGoal = ''
      this.porDevelopmentIndicatorList = []
      this.porDevelopmentGoalList = []
      this.$emit('loadDomainList', this.porDevelopmentObject)
    },
    handleAnalysisGrouping(porDevelopmentObjectTemp) {
      porDevelopmentObjectTemp.termlyReport = true
      let exist = this.porDevelopmentObject.find(d => d.Domain === porDevelopmentObjectTemp.Domain)
      if (!exist) {
        let tempDomain = {
          Domain: porDevelopmentObjectTemp.Domain,
          ItemList: [porDevelopmentObjectTemp],
        }
        this.porDevelopmentObject.push(tempDomain)
      } else {
        exist.ItemList.push(porDevelopmentObjectTemp)
      }
    },
    countMaxAnalysis() {
      let totalObject = []
      this.porDevelopmentObject.forEach(d => {
        if (d.ItemList) {
          totalObject.push(...d.ItemList)
        }
      })
      return totalObject.length >= (this.layoutConfig?.goalMax || 5)
    },
    setAnalysisValue(event, objIndex) {
      let editedText = ''
      if (!this.isNull(event)) {
        editedText = event.target.value
      }

      this.porDevelopmentObject.forEach((val, index) => {
        if (objIndex !== '' && index === objIndex && val.Indicator !== editedText) {
          val.Indicator = editedText

          this.arr_indicatorList[objIndex] = editedText

          let porDevelopmentObjectTemp = {
            PlnMasDomain: val.Domain,
            PlnMasGoals: val.Goals,
            PlnMasIndicator: val.Indicator,
            Included: 'No',
            KeyId: this.ddlGoalsList.length + 1,
          }

          this.ddlGoalsList.push(porDevelopmentObjectTemp)
        }
      })

      this.setValidateDropdown()
    },
    removeSelectedGoals(itemValue, itemIndex) {
      let newPorDevelopmentObject

      this.porDevelopmentObject.forEach(d => {
        if (d.Domain === itemIndex) {
          d.ItemList.splice(itemValue)
          if (d.ItemList.length < 1) {
            newPorDevelopmentObject = this.porDevelopmentObject.filter(d => d.Domain !== itemIndex)
          }
        }
      })
      if (newPorDevelopmentObject) {
        this.porDevelopmentObject = newPorDevelopmentObject
      }

      this.goalsList.forEach((d, dIndex) => {
        if (itemValue.KeyId === d.KeyId) {
          this.porDevelopmentObject = this.porDevelopmentObject.filter((indicator, iIndex) => {
            return indicator.Indicator !== d.PlnMasIndicator
          })
        }
      })
      this.setValidateDropdown(this.goalsList)
    },
    handleRemarks(value) {},
    // hide remarks 9112022
    // addRemarks(item) {
    //   this.$prompt(lang("Please input your remarks"), lang("Remarks"), {
    //     confirmButtonText: lang("OK"),
    //     cancelButtonText: lang("Cancel"),
    //     inputValue: item.remarks
    //   }).then(({ value }) => {
    //     item.remarks = value;
    //     this.$forceUpdate();
    //   }).catch(() => {
    //
    //   });
    // }
  },
}
</script>
